"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsRoutes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../constants/appConstants");
const pageLoader_1 = __importDefault(require("../loaders/pageLoader"));
const rootLoader_1 = require("../loaders/rootLoader");
const settingsCardsLoader_1 = require("../loaders/settings/settingsCardsLoader");
const settingsCodingLoader_1 = require("../loaders/settings/settingsCodingLoader");
const settingsOverviewLoader_1 = require("../loaders/settings/settingsOverviewLoader");
const settingsTeamsLoader_1 = require("../loaders/settings/settingsTeamsLoader");
const protectedRoute_1 = __importDefault(require("../protectedRoute"));
const Root_1 = require("../Root");
const OverviewPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/companySettings/overview'))));
const TeamsPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/companySettings/teams'))));
const CardsPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/companySettings/cards'))));
const CodingPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../components/pages/companySettings/coding'))));
const settingsPath = '/settings';
exports.settingsRoutes = {
    path: settingsPath,
    element: (0, jsx_runtime_1.jsx)(react_router_1.Outlet, {}),
    children: [
        {
            index: true,
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: appConstants_1.defaultAllowedRoles, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(OverviewPage, {}) }) })),
            loader: async (ctx) => {
                const [rootData, overviewData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, settingsOverviewLoader_1.settingsOverviewLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...overviewData,
                };
            },
        },
        {
            path: 'overview',
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: appConstants_1.defaultAllowedRoles, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(OverviewPage, {}) }) })),
            loader: async (ctx) => {
                const [rootData, overviewData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, settingsOverviewLoader_1.settingsOverviewLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...overviewData,
                };
            },
        },
        {
            path: 'teams',
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: appConstants_1.defaultAllowedRoles, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(TeamsPage, {}) }) })),
            loader: async (ctx) => {
                const [rootData, teamsData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, settingsTeamsLoader_1.settingsTeamsLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...teamsData,
                };
            },
        },
        {
            path: 'cards',
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: appConstants_1.defaultAllowedRoles, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(CardsPage, {}) }) })),
            loader: async (ctx) => {
                const [rootData, cardsData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, settingsCardsLoader_1.settingsCardsLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...cardsData,
                };
            },
        },
        {
            path: 'coding',
            element: ((0, jsx_runtime_1.jsx)(protectedRoute_1.default, { allowedRoles: appConstants_1.defaultAllowedRoles, children: (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(CodingPage, {}) }) })),
            loader: async (ctx) => {
                const [rootData, codingData] = await Promise.all([
                    (0, rootLoader_1.rootLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                    (0, settingsCodingLoader_1.settingsCodingLoader)({ queryClient: Root_1.queryClient, ...ctx }),
                ]);
                return {
                    ...rootData,
                    ...codingData,
                };
            },
        },
    ],
};
